import React from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { theme } from '$theme';

export const ThemeProvider: React.FunctionComponent = (props) => {
    return <EmotionThemeProvider theme={theme} {...props} />;
};

export default ThemeProvider;
